import React from "react";

const BoulevardHeights = () => {
  // Additional images for Boulevard Heights
  const additionalImages = [
    "/images/Picture11.jpg",
    "/images/Picture40.jpg",
    "/images/Picture41.jpg",
  ];

  return (
    <div className="w-[90%] mx-auto py-12 flex flex-col gap-12">
      {/* Top Section: Text and Main Image */}
      <div className="flex flex-col lg:flex-row items-start gap-8">
        {/* Left Text Section */}
        <div className="lg:w-2/3 space-y-6">
          <h2 className="text-3xl font-bold text-gray-800">Boulevard Heights, Lahore</h2>
          <h3 className="text-2xl font-bold text-gray-800 leading-tight">
            Construction Services by PACIFIC BUILDERS (PVT) LTD
          </h3>
          <p className="text-gray-700">
            Below is a list of the project details for Boulevard Heights, where <strong>PACIFIC BUILDERS (PVT) LTD</strong> has executed high-standard construction work with an emphasis on precision and quality.
          </p>

          <div className="text-lg text-gray-700">
            <p><strong>Scope of Work:</strong> Civil and finishing works.</p>
            <p><strong>Architect:</strong> Land Mark Consultants</p>
            <p><strong>Project Description:</strong> Boulevard Heights is a 21-floor high-rise commercial building located in Gulberg, Lahore.</p>
            <p><strong>Location:</strong> Main Boulevard, Lahore.</p>
            <p><strong>Client:</strong> HK Group</p>
            <p><strong>Status:</strong> Complete</p>
          </div>
        </div>

        {/* Right Image Section */}
        <div className="lg:w-1/3">
          <img
            src="/images/Picture12.jpg"
            alt="Boulevard Heights Construction"
            className="w-full h-auto rounded shadow"
          />
        </div>
      </div>

      {/* Additional Images Section */}
      {additionalImages.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {additionalImages.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`Boulevard Heights ${index + 1}`}
              className="w-full h-[200px] rounded shadow"
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default BoulevardHeights;
